import { render, staticRenderFns } from "./BottomPc.vue?vue&type=template&id=1b47814c&scoped=true&"
import script from "./BottomPc.vue?vue&type=script&lang=js&"
export * from "./BottomPc.vue?vue&type=script&lang=js&"
import style0 from "./BottomPc.vue?vue&type=style&index=0&id=1b47814c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b47814c",
  null
  
)

export default component.exports